// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"135feef5","613":"2ddc3332","726":"95e8cbf9","851":"58ba0825"}[chunkId] + ".chunk.css";
};